import { GET_SESSION } from '../bridge-methods';
import { shortenName } from '../../../utils/name';
import { isPending } from '../../redux-util/async-helpers';
import { isJigsawOnly } from '../../redux-watson/watson-config-selectors';
import { isCookieError } from '../../bridge-helpers';

export function getDisplayName(state) {
  const base = state.bridge[GET_SESSION].data;
  if (base) {
    return shortenName(base.firstName, base.lastName);
  }
  return '';
}

export function getFullName(state) {
  const base = state.bridge[GET_SESSION].data;
  if (base) {
    return `${base.firstName} ${base.lastName}`;
  }
  return '';
}

export function getFirstName(state) {
  const base = state.bridge[GET_SESSION].data;
  return base ? base.firstName : '';
}

export function getEmail(state) {
  const base = state.bridge[GET_SESSION].data;
  if (base) {
    return base.email;
  }
  return '';
}

export function isLoggedInToBridge(state) {
  const base = state.bridge[GET_SESSION];
  return !isPending(base) && !base.hasError;
}

export function isBridgeSessionPending(state) {
  return isPending(state.bridge[GET_SESSION]);
}

export function getGradeLevel(state) {
  const base = state.bridge[GET_SESSION].data;
  if (base && base.level) {
    return base.level;
  }
  return null;
}

export function isTeacher(state) {
  return !isJigsawOnly(state) && getGradeLevel(state) === null;
}

export function hasCookieError(state) {
  return isCookieError(state.bridge[GET_SESSION].errorInfo);
}



// WEBPACK FOOTER //
// ./src/app/api/redux-bridge/session/selectors.js